import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { ClimateTemplate } from '../../../../core/swagger/models/climate-template';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { DepartmentType, SportType } from '../../../../models/ClimateEntry';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-delete-climate-template',
  templateUrl: './delete-climate-entry.component.html',
  standalone: true,
  imports: [
    MatInputModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
  ],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'de-DE' }],
})
export class DeleteClimateEntryComponent {
  constructor(
    public dialogRef: MatDialogRef<DeleteClimateEntryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ClimateTemplate,
  ) {}

  public onNoClick(): void {
    this.dialogRef.close();
  }
}
